import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { FiBookOpen, FiPlayCircle, FiClock, FiSearch } from 'react-icons/fi';
import api, { RUTA_ARCHIVOS } from '../api/client';
import Estrellas from '../components/Estrellas';

export default function Cursos() {
    const [cursos, setCursos] = useState([]);
    const [busqueda, setBusqueda] = useState('');
    const [categoria, setCategoria] = useState('');
    const [cargando, setCargando] = useState(true);

    useEffect(() => {
        api.get('/cursos').then(r => setCursos(r.data.cursos || [])).finally(() => setCargando(false));
    }, []);

    if (cargando) return <div className="loader"><div className="spinner" /><span>Cargando cursos...</span></div>;

    const categorias = [...new Set(cursos.map(c => c.categoria).filter(Boolean))];
    const filtrados = cursos.filter(c => {
        const matchTxt = !busqueda || c.nombre.toLowerCase().includes(busqueda.toLowerCase()) ||
                         (c.profesor_nombre || '').toLowerCase().includes(busqueda.toLowerCase());
        const matchCat = !categoria || c.categoria === categoria;
        return matchTxt && matchCat;
    });

    return (
        <div>
            <h1 style={{ margin: '0 0 16px', fontSize: 24 }}>Todos los Cursos</h1>

            <div style={{ display: 'flex', gap: 12, marginBottom: 20, flexWrap: 'wrap' }}>
                <div className="input-icono" style={{ flex: 1, minWidth: 200 }}>
                    <FiSearch className="icono" size={16} />
                    <input
                        className="input"
                        placeholder="Buscar cursos o profesor..."
                        value={busqueda}
                        onChange={e => setBusqueda(e.target.value)}
                    />
                </div>
                <select className="input" value={categoria} onChange={e => setCategoria(e.target.value)} style={{ maxWidth: 220 }}>
                    <option value="">Todas las categorias</option>
                    {categorias.map(c => <option key={c} value={c}>{c}</option>)}
                </select>
            </div>

            {filtrados.length === 0 ? (
                <div className="card" style={{ textAlign: 'center', padding: 40, color: 'var(--texto-suave)' }}>
                    No se encontraron cursos
                </div>
            ) : (
                <div className="cursos-grid">
                    {filtrados.map(curso => (
                        <Link key={curso.id} to={`/curso/${curso.id}`} className="curso-card" style={{ textDecoration: 'none', color: 'inherit' }}>
                            <div className="curso-cover">
                                {curso.imagen_portada ? (
                                    <img src={curso.imagen_portada.startsWith('http') ? curso.imagen_portada : `${RUTA_ARCHIVOS}${curso.imagen_portada}`} alt={curso.nombre} />
                                ) : (
                                    <FiBookOpen />
                                )}
                                {curso.nivel && <span className="badge">{curso.nivel}</span>}
                            </div>
                            <div className="curso-body">
                                <h3 className="curso-titulo">{curso.nombre}</h3>
                                <p className="curso-prof">{curso.profesor_nombre || 'Sin profesor'}</p>
                                <div className="curso-meta">
                                    <Estrellas valor={Math.round(curso.calificacion_promedio || 0)} soloLectura tamano={14} />
                                    <span><FiPlayCircle size={12} /> {curso.total_videos || 0}</span>
                                    <span><FiClock size={12} /> {curso.duracion_horas || 0}h</span>
                                </div>
                            </div>
                        </Link>
                    ))}
                </div>
            )}
        </div>
    );
}
